import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { appointmentHasParallelAppointments, ScheduleCalendarElement } from '@libs/store';
import { PushTagOnClickDirective, TagEvent } from '@libs/shared-services';
import { TranslateModule } from '@ngx-translate/core';
import { ScheduleCalendarItemComponent } from '../schedule-calendar-item';
import { ScheduleTimeToGridRowPipe } from '../../schedule-time-to-grid-row';
@Component({
  selector: 'lib-schedule-calendar-my-day',
  templateUrl: './schedule-calendar-my-day.component.html',
  styleUrl: './schedule-calendar-my-day.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScheduleCalendarItemComponent, ScheduleTimeToGridRowPipe, NgClass, PushTagOnClickDirective, TranslateModule],
})
export class ScheduleCalendarMyDayComponent {
  @Input() public myDay: ScheduleCalendarElement[] = [];
  @Input() public selectedAppointmentId?: number;
  @Input() public isShowcase = false;

  @Output() public calendarItemClick = new EventEmitter<number>();

  protected readonly TagEvent = TagEvent;

  protected onCalendarItemClick(appointmentId: number): void {
    this.calendarItemClick.emit(appointmentId);
  }

  protected elementHasParallelAppointments(appointment: ScheduleCalendarElement): boolean {
    return appointmentHasParallelAppointments(appointment, this.myDay);
  }
}
